// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import cookie from 'vue-cookie'
import api from './http/api.js'
import '../static/css/All.css'
import '../static/css/style.css'
import '../static/js/fontsize.js'
import Vant from 'vant'
import 'vant/lib/index.css'
import infiniteScroll from 'vue-infinite-scroll'


Vue.prototype.$cookie = cookie; 
Vue.use(Vant)
Vue.use(infiniteScroll)

Vue.config.productionTip = false
Vue.prototype.$api = api
// 设置不同页面的title
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js